export enum OAuthProvider {
    Amazon = 'amazon',
    Apple = 'apple',
    Auth0 = 'auth0',
    Authentik = 'authentik',
    Autodesk = 'autodesk',
    Bitbucket = 'bitbucket',
    Bitly = 'bitly',
    Box = 'box',
    Dailymotion = 'dailymotion',
    Discord = 'discord',
    Disqus = 'disqus',
    Dropbox = 'dropbox',
    Etsy = 'etsy',
    Facebook = 'facebook',
    Figma = 'figma',
    Github = 'github',
    Gitlab = 'gitlab',
    Google = 'google',
    Linkedin = 'linkedin',
    Microsoft = 'microsoft',
    Notion = 'notion',
    Oidc = 'oidc',
    Okta = 'okta',
    Paypal = 'paypal',
    PaypalSandbox = 'paypalSandbox',
    Podio = 'podio',
    Salesforce = 'salesforce',
    Slack = 'slack',
    Spotify = 'spotify',
    Stripe = 'stripe',
    Tradeshift = 'tradeshift',
    TradeshiftBox = 'tradeshiftBox',
    Twitch = 'twitch',
    Wordpress = 'wordpress',
    Yahoo = 'yahoo',
    Yammer = 'yammer',
    Yandex = 'yandex',
    Zoho = 'zoho',
    Zoom = 'zoom',
    Mock = 'mock',
}